import http from '@/lib/Http'
import Page from "@/models/Page";

const path = '/search'

const searchByConcerned = (concernedId, timeType, page) => {
    const {number, size} = page || new Page()
    return new Promise((resolve, reject) => {
        http.get(path + '/by/concerned', {
            concernedId,
            timeType,
            page: number,
            size
        }).then(resp => {
            if (resp.status === 200) {
                resolve(resp)
            } else {
                reject(resp)
            }
        }).catch(reject)
    })
}

const searchByKeyWord = (keyword, timeType, page) => {
    const {number, size} = page || new Page()
    return http.get(path + '/by/keyword', {
        keyword,
        timeType,
        page: number,
        size
    })
}

const searchByCustomerName = (customerName, timeType, page) => {
    const {number, size} = page || new Page()
    return http.get(path + '/by/customer', {
        customerName,
        timeType,
        page: number,
        size
    })
}

const completionCustomerName = (customerName) => {
    return http.get(path + '/completion/customer/name', {
        customerName
    })
}

export default {
    searchByConcerned,
    searchByKeyWord,
    searchByCustomerName,
    completionCustomerName
}
